import { Checkbox } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelCheckbox = ({ selected, onSelect, padding }) => {
  return (
    <Styles.CheckboxContainer onClick={e => e.stopPropagation()} padding={padding}>
      <Checkbox checked={selected} onChange={onSelect} />
    </Styles.CheckboxContainer>
  )
}

export default ParcelCheckbox
